module.exports = __webpack_public_path__ + "static/media/photographer.6845bd4e.jpg";